<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name:'',
   data() {
     return{

     }
   },
  mounted(){
    // alert(123)
    // this.addListener()
  },
  methods:{
    listenerHandle(e){
      window.event? window.event.cancelBubble = true : e.stopPropagation();
      console.log(e);
      console.log(e.keyCode);
      if(e.keyCode>111 && e.keyCode<124){
        console.log('---');
        // try{
        //   e.keycode=0
        // }catch(e){}
        e.returnValue=false
      }else{
        // e.preventDefault()
      }
    },
    addListener(){
      document.addEventListener('keydown',this.listenerHandle,false)
    }
  }
}
</script>

<style lang="scss">

#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  width: 100%;
  height: 100%;
  // background: #ccc;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}




</style>
